import React from 'react'

import styled from 'styled-components'

export const ReceiptMainContentTable = ({
  totalAmountIncludingTax,
  salesTaxAmount,
  salesTaxRate,
  receiptDetails,
}) => (
  <>
    <StyledMainContentTable>
      <thead>
        <tr>
          <StyledMainContentTableFirstHeader>
            品名
          </StyledMainContentTableFirstHeader>
          <StyledMainContentTableHeader>単価</StyledMainContentTableHeader>
          <StyledMainContentTableHeader>個数</StyledMainContentTableHeader>
          <StyledMainContentTableHeader>税抜</StyledMainContentTableHeader>
          <StyledMainContentTableLastHeader>
            税込
          </StyledMainContentTableLastHeader>
        </tr>
      </thead>
      <tbody>
        {receiptDetails.map(receipt => (
          <tr key={receipt.name}>
            <StyledMainContentTableBodyFirstCell>
              {receipt.name}
            </StyledMainContentTableBodyFirstCell>
            <StyledMainContentTableBodyCell>
              {formatPrice(receipt.unitPrice)}
            </StyledMainContentTableBodyCell>
            <StyledMainContentTableBodyCell>
              {receipt.quantity}
            </StyledMainContentTableBodyCell>
            <StyledMainContentTableBodyCell>
              {formatPrice(receipt.amountExclusiveOfTax, 'ー')}
            </StyledMainContentTableBodyCell>
            <StyledMainContentTableBodyLastCell>
              {formatPrice(receipt.amountIncludingTax, 'ー')}
            </StyledMainContentTableBodyLastCell>
          </tr>
        ))}
        <tr>
          <StyledBlankCell />
        </tr>
        <tr>
          <StyledTotalLabelCell>
            合計({salesTaxRate * 100}%対象)
          </StyledTotalLabelCell>
          <StyledTotalValueCell>
            {formatPrice(totalAmountIncludingTax)}
          </StyledTotalValueCell>
        </tr>
        <tr>
          <StyledTotalTaxLabelCell>内、消費税</StyledTotalTaxLabelCell>
          <StyledTotalTaxValueCell>
            {formatPrice(salesTaxAmount)}
          </StyledTotalTaxValueCell>
        </tr>
      </tbody>
    </StyledMainContentTable>
  </>
)

const formatPrice = (price, placeholder = '') => {
  if (price === undefined || price === null) return placeholder
  if (price >= 0) return `￥${price.toLocaleString()}`
  return `-￥${Math.abs(price).toLocaleString()}`
}

const StyledMainContentTable = styled.table`
  width: 100%;
  margin: 20px 0 30px;
  border-collapse: collapse;
  border-width: 0;
`

const StyledMainContentTableHeader = styled.th`
  font-size: 12px;
  font-weight: 400;
  text-align: right;
  padding: 4px 0 4px 40px;
  white-space: nowrap;
`
const StyledMainContentTableFirstHeader = styled(StyledMainContentTableHeader)`
  width: 50%;
  text-align: left;
  white-space: normal;
  padding: 4px 0 4px 20px;
`

const StyledMainContentTableLastHeader = styled(StyledMainContentTableHeader)`
  padding: 4px 20px 4px 40px;
`

const StyledMainContentTableBodyCell = styled.td`
  white-space: nowrap;
  vertical-align: top;
  font-size: 14px;
  text-align: right;
  border-bottom: 1px solid #222;
  padding: 4px 0 4px 40px;
`
const StyledMainContentTableBodyFirstCell = styled(
  StyledMainContentTableBodyCell,
)`
  width: 50%;
  text-align: left;
  white-space: normal;
  padding: 4px 0 4px 20px;
`

const StyledMainContentTableBodyLastCell = styled(
  StyledMainContentTableBodyCell,
)`
  padding: 4px 20px 4px 40px;
`

const StyledBlankCell = styled.td.attrs({
  colSpan: 5,
})`
  padding-top: 80px;
  border-bottom: 1px solid #222;
`

const StyledTotalLabelCell = styled.td.attrs({
  colSpan: 4,
})`
  text-align: right;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  padding: 12px 0 0;
`

const StyledTotalValueCell = styled.td.attrs({
  colSpan: 1,
})`
  text-align: right;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  padding: 12px 20px 0 20px;
`

const StyledTotalTaxLabelCell = styled.td.attrs({
  colSpan: 4,
})`
  text-align: right;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  padding: 20px 0 0;
`

const StyledTotalTaxValueCell = styled.td.attrs({
  colSpan: 1,
})`
  text-align: right;
  font-size: 14px;
  font-weight: 700;
  line-height: 1;
  padding: 20px 20px 0 20px;
`
